import { Injectable } from '@angular/core';
import { CustomerDepartmentQualificationsListItemResponse } from '../../../api';
import { BaseQualificationsInterface } from '../../modules/administration/_interfaces/base-qualifications.interface';

@Injectable({ providedIn: 'root' })
export class BaseDepartmentQualificationsService {
  getGroupedQualificationsByCategory(qualificationsList: CustomerDepartmentQualificationsListItemResponse[]) {
    return qualificationsList.reduce((acc, item) => {
      const categoryId = item.category?.id as number;
      if (!acc[categoryId]) {
        acc[categoryId] = [];
      }
      acc[categoryId].push(item);
      return acc;
    }, {} as BaseQualificationsInterface);
  }
}
